export default __webpack_public_path__ + "static/media/image-cushion-b-w.00c03f01.webp";